var landingPageRoot = "beneficiaryLandingPageEvent.";
var editPageRoot = "beneficiaryEditPageEvent.";

var beneficiaryPageEvents = {
    //initial landing page
    LANDING_PAGE_VIEW: landingPageRoot + "page_view",
    LANDING_PAGE_ADD: landingPageRoot + "add",
    LANDING_PAGE_EDIT: landingPageRoot + "edit",
    LANDING_PAGE_SAVE: landingPageRoot + "save",
    //edit / add page
    EDIT_PAGE_CONTINUE: editPageRoot + "continue",
    EDIT_PAGE_CANCEL: editPageRoot + "cancel",
    EDIT_PAGE_DELETE: editPageRoot + "delete",
    EDIT_PAGE_SPOUSAL_DOC: editPageRoot + "spousal_document",
    EDIT_PAGE_QJSA_DOC: editPageRoot + "qjsa_document"
};

export default beneficiaryPageEvents;
